import * as hooks from './hooks';

export const useSportsbookIntegration = () => {
    hooks.useSportsbookRootURL();
    hooks.useSportsbookDestroyOnLangChange();
    hooks.useSportsbookFetch();
    hooks.useSportsbookInit();
    hooks.useSportsbookCookie();
    hooks.useSportsbookListeners();
    hooks.useSportsbookBalance();
    hooks.useSportsbookSyncSession();
};
